export const DrawerTokenSections = {
  root: {
    fontSize: "16px",
  },
  colorScheme: {
    light: {
      color: "#000",
    },
    dark: {
      color: "#fff",
    },
  },
};
